var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:#fff;}.cls-11,.cls-17,.cls-2,.cls-20,.cls-22,.cls-23,.cls-25,.cls-3,.cls-37,.cls-4,.cls-8{fill:none;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-8{stroke:#c0ccd8;}.cls-11,.cls-17,.cls-2,.cls-20,.cls-22,.cls-23,.cls-25,.cls-37,.cls-4{stroke-miterlimit:10;}.cls-24,.cls-3,.cls-5,.cls-8{stroke-linejoin:round;}.cls-4{stroke-width:3px;}.cls-6{fill:#b5252d;}.cls-7{fill:#c0ccd8;}.cls-8{stroke-linecap:round;}.cls-9{fill:#475577;}.cls-10{fill:#717a91;}.cls-11{stroke:#544943;stroke-width:1.5px;}.cls-12,.cls-31{opacity:0.45;}.cls-13,.cls-31{fill:#8e9db2;}.cls-14{fill:#ffcbbb;}.cls-15,.cls-24{fill:#e6e8ef;}.cls-16{fill:#b9b5b2;}.cls-17,.cls-24{stroke:#846a6a;}.cls-18{fill:#173789;}.cls-19{fill:#fca32d;}.cls-20{stroke:#ce680d;}.cls-21{fill:#ffb548;}.cls-22,.cls-23{stroke:#ed841b;}.cls-23{stroke-dasharray:3 2;}.cls-25{stroke:#ef977f;}.cls-26{fill:#8ebca2;}.cls-27{fill:#a2ccb6;}.cls-28{fill:#597f6e;}.cls-29{fill:#f2f5f9;}.cls-30{fill:#e7eaf2;}.cls-32{fill:#c6d2e0;}.cls-33{opacity:0.65;}.cls-34{opacity:0.55;}.cls-35{fill:url(#linear-gradient);}.cls-36{fill:#e8eaef;}.cls-37{stroke:#475577;stroke-width:2px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 293.13,
    y1: 254.36,
    x2: 293.13,
    y2: 226.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.4
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 750,
    height: 500
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 248.89,
    y: 77.51,
    width: 123.75,
    height: 74.75,
    rx: 3.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 248.89,
    y1: 91.05,
    x2: 372.64,
    y2: 91.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 256.88,
    cy: 84.35,
    r: 1.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267,84.35a2,2,0,1,1-2-2A2,2,0,0,1,267,84.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.14,84.35a2,2,0,1,1-2-2A2,2,0,0,1,275.14,84.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 178.85,
    y: 120.57,
    width: 39.5,
    height: 39.5,
    rx: 5.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.6,
    cy: 140.32,
    r: 11.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 206.24,
    y1: 132.34,
    x2: 190.27,
    y2: 148.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M480.24,151.09l-8.19-8.49H346a10.68,10.68,0,0,1-10.68-10.68V66.36A10.68,10.68,0,0,1,346,55.68H472.61a10.68,10.68,0,0,1,10.68,10.68v83.5A1.77,1.77,0,0,1,480.24,151.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M386,113.29h-5.43v9.54H367.39v-9.54H347.75v-9.77l20.49-29.95h12.29v29.78H386Zm-18.57-9.94V97.62c0-1.07,0-2.53.12-4.36a26.15,26.15,0,0,1,.19-2.88h-.37a35.47,35.47,0,0,1-2.6,4.85l-5.46,8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M427,98.26q0,13.08-4.38,19.16t-13.41,6.08q-8.84,0-13.31-6.35t-4.48-18.89q0-13.14,4.38-19.27t13.41-6.13q8.79,0,13.29,6.39T427,98.26Zm-22.34,0c0,5.58.35,9.4,1,11.49s1.87,3.14,3.51,3.14,2.83-1.08,3.52-3.24,1-6,1-11.39-.35-9.28-1-11.47-1.86-3.28-3.5-3.28-2.81,1-3.51,3.16S404.67,92.65,404.67,98.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M470.82,113.29h-5.43v9.54H452.25v-9.54H432.61v-9.77L453.1,73.57h12.29v29.78h5.43Zm-18.57-9.94V97.62c0-1.07,0-2.53.12-4.36a26.15,26.15,0,0,1,.19-2.88h-.37a35.47,35.47,0,0,1-2.6,4.85l-5.46,8.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 593.93,
    y: 235.59,
    width: 39.5,
    height: 39.5,
    rx: 5.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M626.41,266.43a1.5,1.5,0,0,1-.47.08H601.42a1.44,1.44,0,0,1-1.24-2.16l12.25-21.23a1.42,1.42,0,0,1,1.24-.72,1.46,1.46,0,0,1,1.25.71l12.26,21.23a1.44,1.44,0,0,1-.77,2.08Zm-24.31-1.74h23.16l-11.59-20.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M613.68,260.47h0a.86.86,0,0,1-.87-.83l-.5-8.35a1.37,1.37,0,0,1,1.36-1.43h0a1.37,1.37,0,0,1,1.37,1.42l-.5,8.36A.86.86,0,0,1,613.68,260.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M614.56,262.49a.88.88,0,1,1-.88-.89A.88.88,0,0,1,614.56,262.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96.44,204.5a2.23,2.23,0,1,1-2.23-2.23A2.23,2.23,0,0,1,96.44,204.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M470.82,323.31a2.23,2.23,0,1,1-2.23-2.22A2.23,2.23,0,0,1,470.82,323.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M623.94,140.32a2.23,2.23,0,1,1-2.23-2.22A2.23,2.23,0,0,1,623.94,140.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M503.66,71.4a2.23,2.23,0,1,1-2.23-2.22A2.23,2.23,0,0,1,503.66,71.4Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 619.49,
    y1: 213.2,
    x2: 619.49,
    y2: 220.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 622.94,
    y1: 216.65,
    x2: 616.03,
    y2: 216.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 439.1,
    y1: 346.14,
    x2: 439.1,
    y2: 353.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 442.55,
    y1: 349.59,
    x2: 435.65,
    y2: 349.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 293.16,
    y1: 58.68,
    x2: 293.16,
    y2: 65.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 296.61,
    y1: 62.13,
    x2: 289.71,
    y2: 62.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 138.7,
    y1: 125.37,
    x2: 138.7,
    y2: 132.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 142.15,
    y1: 128.83,
    x2: 135.25,
    y2: 128.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 127.46,
    y1: 284.25,
    x2: 127.46,
    y2: 291.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 130.91,
    y1: 287.7,
    x2: 124.01,
    y2: 287.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 518.61,
    y1: 97.75,
    x2: 518.61,
    y2: 104.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 522.06,
    y1: 101.2,
    x2: 515.16,
    y2: 101.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.8,245H109.75a2.19,2.19,0,0,1-2.18-2.18h0a2.19,2.19,0,0,1,2.18-2.19H178.8a2.19,2.19,0,0,1,2.19,2.19h0A2.19,2.19,0,0,1,178.8,245Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M585.37,189.82h-69a2.19,2.19,0,0,1-2.19-2.18h0a2.19,2.19,0,0,1,2.19-2.19h69a2.19,2.19,0,0,1,2.18,2.19h0A2.19,2.19,0,0,1,585.37,189.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M595.47,204.5H570a1.09,1.09,0,0,1-1.09-1.09h0a1.09,1.09,0,0,1,1.09-1.09h25.52a1.09,1.09,0,0,1,1.1,1.09h0A1.09,1.09,0,0,1,595.47,204.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M527.93,152.47H502.4a1.09,1.09,0,0,1-1.09-1.1h0a1.09,1.09,0,0,1,1.09-1.09h25.53a1.09,1.09,0,0,1,1.09,1.09h0A1.09,1.09,0,0,1,527.93,152.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M153.14,225.66H133.61a1.09,1.09,0,0,1-1.09-1.1h0a1.09,1.09,0,0,1,1.09-1.09h19.53a1.09,1.09,0,0,1,1.09,1.09h0A1.09,1.09,0,0,1,153.14,225.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 543.55,
    y: 100.74,
    width: 28.54,
    height: 28.54,
    rx: 3.7,
    transform: "translate(1115.64 230.02) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M561.86,113.81l-.49,2.45h2.72v2.17H561l-.81,4.29h-2.32l.82-4.29h-3l-.81,4.29h-2.27l.78-4.29h-2.51v-2.17h2.93l.49-2.45h-2.66V111.6h3l.82-4.3h2.31l-.81,4.3h3l.83-4.3h2.27l-.83,4.3h2.54v2.21Zm-5.81,2.45h3l.5-2.45h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M317.5,326.72,297.45,195.23h-90.3L228.8,334.56a18.88,18.88,0,0,0,19,16.09H399.69l1.11-12.76H330.68A13.07,13.07,0,0,1,317.5,326.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M232,326.72,212.73,200.09a5.69,5.69,0,0,0-5.75-4.86h-.17a7,7,0,0,0-6.86,7.84l20.43,131.49a18.88,18.88,0,0,0,19.05,16.09h97.79l1.12-12.76H245.22A13.06,13.06,0,0,1,232,326.72Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 293.16,
    y1: 350.65,
    x2: 293.16,
    y2: 422.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M252.93,428.77h0a6.34,6.34,0,0,1,6.34-6.34h67.79a6.34,6.34,0,0,1,6.34,6.34h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M286.23,428.77h0a6.34,6.34,0,0,1,6.34-6.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M259.33,435.17a6.41,6.41,0,1,1-6.4-6.4A6.4,6.4,0,0,1,259.33,435.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M255.28,435.17a2.36,2.36,0,1,1-2.35-2.35A2.35,2.35,0,0,1,255.28,435.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M292.63,435.17a6.41,6.41,0,1,1-6.4-6.4A6.4,6.4,0,0,1,292.63,435.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M288.58,435.17a2.36,2.36,0,1,1-2.35-2.35A2.35,2.35,0,0,1,288.58,435.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M339.8,435.17a6.4,6.4,0,1,1-6.4-6.4A6.4,6.4,0,0,1,339.8,435.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M335.75,435.17a2.35,2.35,0,1,1-2.35-2.35A2.35,2.35,0,0,1,335.75,435.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M363.74,209.34l22.88-34.19,7.1,1.47c-5.42,18.26-9,25.48-9,25.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M390.07,182.29l3.65-5.67s6.79-1.56,9.25-2.82a10.15,10.15,0,0,0,4.8-5.38c.53-1.44.3-5.69-.32-5.76-1.46-.16-4.37,5.28-5.73,5.61s-5.79,0-8.22.3a8,8,0,0,0-5.82,4.37l-3.74,6.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "378.69 185.16 382.71 179.33 393.11 184 389.81 192.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M295.19,173s16.95-7.8,31.88,5.48,25,25.62,30.5,29.61l22.49-25.87,12.56,5.9c-3.31,18.73-12.61,48.61-35.35,51.69-24.61,3.32-60.7-27-60.7-27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 350.28,
    y1: 216.65,
    x2: 357.57,
    y2: 208.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M386.23,430.76l-1.9,7.3a2.8,2.8,0,0,0,2.71,3.51h22.14a2.41,2.41,0,0,0,2.41-2.41h0a2.42,2.42,0,0,0-1.68-2.3l-15.13-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M373.47,316.62c-3.54,37.15,12.76,114.14,12.76,114.14s3.87,4.68,8.55,0c0,0,3.93-73.41,8.06-106.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M320.65,273.1l25.41,13.33v.26s51.85-3.48,59.69,15C418,330.71,420.12,425,420.12,425H382.17s-14.12-79.19-18.95-84-24.74-4.48-61.36-4.48c-41.13,0-21.05-53-5.74-57.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M384.8,425s-11.28-81.72-19.57-87.71c-10.12-7.32-57.91-2.54-57.91-2.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M306.65,430.76l-1.9,7.3a2.8,2.8,0,0,0,2.71,3.51H329.6a2.41,2.41,0,0,0,2.41-2.41h0a2.42,2.42,0,0,0-1.68-2.3l-15.13-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M310.33,316.62c-3.53,37.15-3.68,114.14-3.68,114.14s3.87,4.68,8.55,0c0,0,13.32-73.41,17.46-106.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M275.83,284.77s66.66,1.07,75.37,21.27c10.73,24.83-6.95,119-6.95,119H304.08v-84.2a3,3,0,0,0-2.91-3.05c-5.56.15-18,.15-33.74.15-41.13,0-21.05-64-5.74-68.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M275.83,284.77s66.66,1.07,75.37,21.27c2.91,6.73,4.42,18.19,3.64,31.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M309.68,425s.41-84.52-1.53-89c-2.7-6.27-11.91-3.19-33.28-3.19-41.13,0-24.37-58.88-9.06-63.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M250.23,295.06s21.11.51,24.31-2.69,0-17.7,0-17.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M249.71,297.89s24.11.52,27.76-2.69,0-17.73,0-17.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M245.64,196.79s-5.06,89.9,2.6,89.9,92.83-.26,97.82-.26-6.69-76.88-23.51-93.12c0,0-24.95-27.07-35.95-24.48S245.64,196.79,245.64,196.79Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 340.65,
    y1: 237.68,
    x2: 330.08,
    y2: 194.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M202.56,213.07l-22.89-34.19-7.09,1.47c5.42,18.25,9,25.48,9,25.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M176.23,186l-3.65-5.66s-6.79-1.56-9.26-2.82a10.19,10.19,0,0,1-4.8-5.38c-.53-1.44-.3-5.69.32-5.76,1.46-.16,4.37,5.28,5.73,5.61s5.79,0,8.22.3a8,8,0,0,1,5.82,4.37l3.74,6.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "187.6 188.89 183.58 183.06 173.18 187.73 176.49 196.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M277.11,173.48s-16.75-11.9-34,2.72c-16.12,13.63-26.86,41.14-30.46,41.14-2.51,0-18-19.77-27.27-31.88l-11,5.89c6.94,21.19,22.08,57.24,44.72,57.24,17.76,0,54.24-41.61,54.24-41.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 244.18,
    y1: 235.28,
    x2: 271.17,
    y2: 212.77
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-24",
    points: "278.72 175.61 294.82 192.85 296.92 172.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M291.65,158.2l4.53,9.92s1.82,5.69-5.73,8.26a12.58,12.58,0,0,1-13.34-2.9l-1.19-15.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.68,167.81s5.95,7.47,13.77,8.57l-5.68,8.43c-4.6-2.59-10.23-12.65-10.23-12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.7,166.76a20,20,0,0,1-5.25,9.62l6.47,4.89c1.49-3.66,1.32-9.36,1.32-9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M298.36,142.18s4.27,16.36-2.15,20.5-17.57-2.16-18.22-4.21-3.55-19.52.63-20.84C286.06,135.31,296.17,135.2,298.36,142.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M298.22,147.49a.84.84,0,1,1-1-.62A.83.83,0,0,1,298.22,147.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M296.79,142.61c.28,0,1.54.17,1.27.79-.12.28-.56.27-.8.26a1.77,1.77,0,0,0-.76,0,.76.76,0,0,1,.16.26c.08.18-.54.2-.61.2a3.35,3.35,0,0,0-2.11.39A2.8,2.8,0,0,1,296.79,142.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M287.93,149.75a.84.84,0,1,0,.79-.88A.84.84,0,0,0,287.93,149.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M285.46,146.45c-.6.32-1.1.76-1,1.26s.5.3.75.1a4.19,4.19,0,0,1,1.37-.72.92.92,0,0,0-.34.75,3.57,3.57,0,0,0,3.09-3.06,6,6,0,0,1-1.17.8C287.31,146,286.34,146,285.46,146.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M294.06,148.46s2.28,5.75,1.47,6.25-3.68.42-3.68.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M294.15,163.63a13.12,13.12,0,0,1-12.21-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M290.45,159.79s.58-2.53,4.74-2.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M302,133.4a3.53,3.53,0,0,0-.72-2.18,3.37,3.37,0,0,0-2.49-.78,14.91,14.91,0,0,0-8.82,2.81l2.09-1.82c.56-.48,1.79-1.24,1.2-2.14s-2-.34-2.78-.35c-3.58,0-7,1.24-10.33,2.5a26.37,26.37,0,0,0-4.73,2.19,8.9,8.9,0,0,0-3.48,3.79,10.79,10.79,0,0,0-.74,4.48,54.86,54.86,0,0,0,.88,8.17c.47,3,1.18,8.77,5.15,9.13a3.26,3.26,0,0,0,2.23-.34,2.81,2.81,0,0,0,.93-2,10.43,10.43,0,0,0-.23-3.69c.74.4,1.44,1.08,2.28.95a.8.8,0,0,0,.65-.45,1.14,1.14,0,0,0,0-.52c-.31-2.83-.47-5.64-.66-8.48q6.09-1.29,12.25-2.22c1.82-.27,3.75-.57,5.16-1.75C301.85,139,302.2,136,302,133.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M281,154.24c-.68-1.66-1.85-3.67-3.7-2.54a3.68,3.68,0,0,0-1.27,2.08c-.84,2.75,1.13,7,3.83,6.6,1.31-.2,2-1.76,2.58-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M526.15,332.89a32.63,32.63,0,0,1,21.42-30.72c2.33-.85,13.45-1.69,13.45-1.69s-1.29,8.49-3.51,12.77c-5.17,10-15.39,18.36-31.36,19.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M558.88,358.24a27.06,27.06,0,0,1,34.53-6.34.8.8,0,0,1,.42.43.82.82,0,0,1-.28.65,25.17,25.17,0,0,1-20.92,8.14,90.79,90.79,0,0,1-13.75-2.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M567.82,344.69c0-7.76,2.59-14.73,7.15-19.3a21.52,21.52,0,0,1,18-5.86,1,1,0,0,1,.66.28,1.21,1.21,0,0,1,.21.9c-.39,9.35-5.08,17.09-12.23,20.19a70,70,0,0,1-13.78,3.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M579.88,330.8A65.73,65.73,0,0,1,591,317.34a27.77,27.77,0,0,1,5.61-4.22c6.69-3.59,14.94-2.48,22.13,0-2.86,5.43-6.59,10.75-12.08,13.5a33,33,0,0,1-7.74,2.47c-5.26,1.17-13.67,1.05-19,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M576.05,317.83c-13.38-7-15.35-21.63-15.69-27-.21-3.38,0-7.15,2.83-9.59,16.58,5.84,20.82,17.06,12.86,36.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M518.39,315.72c1-7.12,2-14.77-1.24-21.19a25.33,25.33,0,0,0-4.62-6.18c-4.35-4.48-10-8.18-16.29-8.19A28.48,28.48,0,0,0,515.58,312"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M557.31,362.3A28.91,28.91,0,0,1,539.67,324a.92.92,0,0,1,1.57-.55c11.54,6.63,19.44,25.94,16.07,38.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M525.94,323a28.29,28.29,0,0,1,13-34c2.35-1.3,4.91-2.28,7-4a66.32,66.32,0,0,1,1.42,9.51,28,28,0,0,1-.61,9.45c-2.17,7.91-9.46,13.29-16.78,17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M516.27,321.77c-12,1.45-26.81-3.4-33.24-14.72,20.55-10.44,33.24,5.54,33.24,14.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M523.28,348.58c-2.69-9.23-9.78-16.8-18.33-19.56a26.23,26.23,0,0,0-25.2,5.47,1.28,1.28,0,0,0-.57,1,1.33,1.33,0,0,0,.28.63c4.6,6.65,11.93,10.57,19.42,12.22s15.23,1.26,22.86.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M507.83,299.37c6.23,6.23,10.12,14.13,13,22.36a187.61,187.61,0,0,1,6.94,26.18c3.69,18.67,4.67,37.56,6.82,56.43,0,.26.44.28.43,0a370.93,370.93,0,0,0-6.72-57.55,170.53,170.53,0,0,0-7.57-27.17C517.86,312,514,304.81,508,299.17c-.14-.13-.34.07-.21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M529.93,356.32c-4.61-7.47-12.26-11.88-20.21-15.11-8.88-3.61-19-5.88-28.58-5.23a.19.19,0,0,0,0,.37c17.53.78,37.58,5,48.37,20.22.18.26.59,0,.42-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M526.29,338.78c-.07-7-.81-14.1.58-21.07A44.36,44.36,0,0,1,534.62,300c.11-.16-.14-.35-.27-.21-9.4,10.58-9.51,25.7-8.28,39,0,.14.23.15.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M498.41,310.92c5.14.64,9.68,4.09,13.57,7.28s7.33,6.84,11.19,10c.15.12.37-.08.22-.23A131.35,131.35,0,0,0,511,317c-3.65-2.83-7.83-5.72-12.56-6.15-.07,0-.07.09,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M552.62,379.9c2.82-14.62,8.7-28,18.47-39.37a82.26,82.26,0,0,1,16.09-14.4c6.27-4.25,13-7.15,20-9.81a.24.24,0,0,0-.13-.47c-14.19,3.7-27.27,13.5-36.64,24.54s-16.43,25-18.17,39.46c0,.21.32.26.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M568.88,292.52c7,14.8,9.63,31.59,2.51,46.82a.26.26,0,0,0,.46.26c8.54-14.22,4.4-33.37-2.61-47.29-.13-.24-.48,0-.36.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M578,370.19V381.9c0,46.46-12.23,59.67-12.23,59.67H527.93s-12.24-13.21-12.24-59.67V370.19Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 171.35,
    y1: 441.57,
    x2: 203.47,
    y2: 287.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 235.58,
    y1: 441.57,
    x2: 203.47,
    y2: 287.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 495.72,
    y1: 441.57,
    x2: 527.84,
    y2: 287.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 559.96,
    y1: 441.57,
    x2: 527.84,
    y2: 287.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 172.39,
    y: 278.37,
    width: 383.62,
    height: 9.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M537.52,260.81H402a3.89,3.89,0,0,1-3.83-4.57l15.58-87.61a5.81,5.81,0,0,1,5.72-4.8H555a3.89,3.89,0,0,1,3.83,4.57L543.25,256A5.81,5.81,0,0,1,537.52,260.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M540.68,260.81H405.11a3.89,3.89,0,0,1-3.83-4.57l15.58-87.61a5.81,5.81,0,0,1,5.72-4.8H558.15A3.89,3.89,0,0,1,562,168.4L546.4,256A5.81,5.81,0,0,1,540.68,260.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M515.73,260.81h-78.3a2.25,2.25,0,0,1-2.21-2.64l9-50.6a3.37,3.37,0,0,1,3.31-2.77h78.3a2.25,2.25,0,0,1,2.21,2.64L519,258A3.37,3.37,0,0,1,515.73,260.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M517.61,260.81h-78.3a2.24,2.24,0,0,1-2.21-2.64l9-50.6a3.35,3.35,0,0,1,3.3-2.77h78.3a2.24,2.24,0,0,1,2.21,2.64l-9,50.6A3.35,3.35,0,0,1,517.61,260.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 468.48,
    y: 231.05,
    width: 31.78,
    height: 29.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M498.43,231.05H468.48v8.55l8.17,33.94h31.8Zm-7.69,33.43c-3.56,0-7.32-4.15-8.41-9.27s.93-9.28,4.49-9.28,7.33,4.15,8.41,9.28S494.3,264.48,490.74,264.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M451,273.54h71.18v4.83h-76A4.83,4.83,0,0,1,451,273.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 465.23,
    y: 273.54,
    width: 56.91,
    height: 4.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M500.27,231.05H468.48l10,42.49h31.8Zm-7.8,33.43c-3.56,0-7.33-4.15-8.41-9.27s.92-9.28,4.48-9.28,7.33,4.15,8.41,9.28S496,264.48,492.47,264.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "426.02 172.46 424.14 183.05 426.02 183.05 427.9 172.46 426.02 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "431.47 172.46 429.59 183.05 431.47 183.05 433.35 172.46 431.47 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "436.92 172.46 435.04 183.05 436.92 183.05 438.8 172.46 436.92 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "442.37 172.46 440.49 183.05 442.37 183.05 444.25 172.46 442.37 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "447.82 172.46 445.94 183.05 447.82 183.05 449.7 172.46 447.82 172.46"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "497.55 172.46 495.67 183.05 497.55 183.05 499.43 172.46 497.55 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "503.28 172.46 501.39 183.05 503.28 183.05 505.16 172.46 503.28 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "509 172.46 507.12 183.05 509 183.05 510.89 172.46 509 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "514.73 172.46 512.85 183.05 514.73 183.05 516.62 172.46 514.73 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "520.46 172.46 518.58 183.05 520.46 183.05 522.34 172.46 520.46 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "526.19 172.46 524.3 183.05 526.19 183.05 528.07 172.46 526.19 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "531.91 172.46 530.03 183.05 531.91 183.05 533.8 172.46 531.91 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "537.64 172.46 535.76 183.05 537.64 183.05 539.52 172.46 537.64 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "543.37 172.46 541.48 183.05 543.37 183.05 545.25 172.46 543.37 172.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "549.09 172.46 547.21 183.05 549.09 183.05 550.98 172.46 549.09 172.46"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M280.45,254.36a2.28,2.28,0,0,0,1.25-.66c.74-1-.49-2.12-1.29-2.64-1-.65-2.44-.87-2.94-2.14s.41-3,1.58-3.77a15.2,15.2,0,0,1,3.26-1.4,6.3,6.3,0,0,0,3.21-2.37c.91-1.45.73-3.31.84-4.94.47-6.38,7-9.55,12.49-9.68,2.75-.06,6.94.92,8.77,3.06a5.45,5.45,0,0,1,1.26,2.5,4.54,4.54,0,0,1-1.23,3.84,40.16,40.16,0,0,1-3.27,2.68c-1.06,1-.3,2.06-.55,3.26s-1.16,1.9-2.31,2.54c-2.44,1.36-5.31,1.7-8,2.44a6.39,6.39,0,0,0-2.33,1,12.87,12.87,0,0,0-2,2.64,8.35,8.35,0,0,1-5,3.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M295.74,270.43h-5.21v-2.49h5.21a3,3,0,0,0,3.05-3v-4.29a3,3,0,0,0-3.05-3h-5.21v-2.49h5.21a5.54,5.54,0,0,1,5.53,5.53v4.29A5.54,5.54,0,0,1,295.74,270.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M273.4,251.56h21a0,0,0,0,1,0,0v19.29a6.12,6.12,0,0,1-6.12,6.12h-8.79a6.12,6.12,0,0,1-6.12-6.12V251.56A0,0,0,0,1,273.4,251.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M270,273.42s.21,4.95,7.9,4.95H290c7.69,0,7.89-4.95,7.89-4.95Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 327.75,
    y: 276.39,
    width: 111.28,
    height: 1.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 331.56,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 343.63,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 355.7,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 367.77,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 379.84,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 391.91,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 403.98,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 416.05,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 428.13,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 329.21,
    y: 276.39,
    width: 111.28,
    height: 1.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 333.01,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 345.08,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 357.16,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 369.23,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 381.3,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 393.37,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 405.44,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 417.51,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 429.58,
    y: 274.8,
    width: 7.97,
    height: 1.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M170.86,353A24.27,24.27,0,0,0,157.2,324.9c-2.1-.94-4.36-1.59-6.27-2.89a56.81,56.81,0,0,0-.51,8.24,23.81,23.81,0,0,0,1.22,8.05c2.44,6.61,9.08,10.67,15.62,13.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M171.66,370.74c.21-12.79.37-27.39-9.69-36.91a.16.16,0,0,0-.23.23,36.26,36.26,0,0,1,8.7,18.48c.84,6,.5,12.14,1,18.2a.11.11,0,0,0,.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M155.32,387.51A28.46,28.46,0,0,0,144,368.3a28.07,28.07,0,0,0-10.23-4.63c-2.07-.48-11.64,0-11.64,0s2,7.09,4.38,10.5c5.49,7.94,15.11,14,28.86,13.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M147,363.06a53.45,53.45,0,0,0-2.51-13.51,22.23,22.23,0,0,0-2.21-5c-3.15-5-9.07-7.36-14.76-8.39-.07,4.84.48,9.93,3.15,13.91a25.39,25.39,0,0,0,4.27,4.64c3.08,2.8,8.74,5.89,12.06,8.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M179.25,346.34c-.89-6.12-1.72-12.69,1.07-18.21a21.57,21.57,0,0,1,4-5.31c3.74-3.84,8.63-7,14-7a24.66,24.66,0,0,1-3.22,16.76c-3,5-10.27,12-15.8,13.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M169.42,381.88A21.35,21.35,0,0,0,194.89,364a.68.68,0,0,0-.8-.93c-9.83-.06-22,9.33-24.67,18.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M149.19,359.76c8.1-4.56,13.31-13.69,13.46-23.62-5.85-.33-10.25,3.27-12.8,6.37-3.54,4.32-3.84,11.91-.66,17.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M155.08,375.78a17.89,17.89,0,0,1,16.51-24.55c.25,0,.53,0,.66.22a.74.74,0,0,1,.11.41c.22,5-2,9.83-5.11,13.7s-7.18,6.89-11.23,9.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M188.13,332.1c-10.79,10.26-14.57,26.7-17.44,40.74a306.34,306.34,0,0,0-5.78,49.61c0,.28.4.27.43,0,1.94-16.2,2.7-32.44,5.88-48.49,2.83-14.32,6.47-30.94,17.11-41.65.13-.13-.07-.33-.2-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M155.07,384.35a51.69,51.69,0,0,1,1.75-13.94.19.19,0,0,0-.34-.14c-2,3.92-2.62,9.83-1.89,14.15,0,.27.49.21.48-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M155.74,343c-6.47,5.87-8.12,18.17-5.48,26.14a.16.16,0,0,0,.31-.08c-1.92-8.33-1.29-19.63,5.25-26,0,0,0-.11-.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M158.1,412.54a112.33,112.33,0,0,0-4.61-33.94c-3.07-10.67-8-22.25-16.12-30.08-.23-.22-.53.11-.34.34A84.24,84.24,0,0,1,146.71,363a88.1,88.1,0,0,1,6.42,16.54c3.06,10.87,3.93,21.84,4.6,33.05a.19.19,0,0,0,.37,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M191.19,392.88v8c0,31.69-10.51,40.7-10.51,40.7H148.15s-10.51-9-10.51-40.7v-8Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 119.78,
    y1: 441.57,
    x2: 630.22,
    y2: 441.57
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.bd4dbb90e7b915b218640619e0e0366e.svg";
export { ForwardRef as ReactComponent };